/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GlobalSummaryDefinition = {
  readonly id?: number;
  name: string;
  visibility?: GlobalSummaryDefinition.visibility;
  spreadsheet_definition?: any;
  view_kind?: GlobalSummaryDefinition.view_kind;
  dashboard_definition?: any;
  readonly created_by?: number | null;
  readonly created_at?: string;
  readonly updated_at?: string;
  type: GlobalSummaryDefinition.type;
  is_default?: boolean;
};
export namespace GlobalSummaryDefinition {
  export enum visibility {
    USER = 'user',
    FIRM = 'firm',
    SCALAR = 'scalar',
    PUBLIC = 'public',
  }
  export enum view_kind {
    SPREADSHEET = 'spreadsheet',
    DASHBOARD = 'dashboard',
  }
  export enum type {
    FIRM = 'firm',
    FUND = 'fund',
    VALUATIONS = 'valuations',
  }
}
